export default {"src":"/_next/static/media/arrawIcon-2.41e892f2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};